/**
 * Microwave Persona - Quiz Definitions (Arabic)
 *
 * Arabic translation of quizzes.js - structure and logic values are identical.
 */

export const moduleQuizzes = {
  'quiz-microwave-basics': {
    intro: "هيا نختبر فهمك لأساسيات الميكروويف. سأقرأ كل سؤال مع 4 خيارات. يرجى النقر على إجابتك على الشاشة - الإجابات الصوتية غير مدعومة في الاختبارات.",
    questions: [
      {
        question: "ما هو النطاق الترددي النموذجي للميكروويف؟",
        options: [
          "30 هرتز – 300 هرتز",
          "300 ميجاهرتز – 300 جيجاهرتز",
          "1 تيراهرتز – 10 تيراهرتز",
          "50 كيلوهرتز – 100 كيلوهرتز"
        ],
        correctIndex: 1,
        explanation: "يقع الميكروويف بين موجات الراديو والأشعة تحت الحمراء على الطيف."
      },
      {
        question: "أي خاصية تصف طبيعة \"الخط البصري\" للميكروويف؟",
        options: [
          "يمكنه الانحناء حول انحناء الأرض.",
          "ينتقل بشكل عام في مسارات مستقيمة ويتطلب مساراً واضحاً بين الهوائيات.",
          "يعمل فقط تحت الماء.",
          "لا يتأثر بالعوائق المادية مثل المباني."
        ],
        correctIndex: 1,
        explanation: "على عكس راديو AM منخفض التردد، الميكروويف لا \"يركب\" الغلاف الجوي؛ بل يتطلب مساراً مباشراً."
      }
    ],
    passingScore: 1,
    completionMessage: "عمل رائع! أنت تفهم أساسيات الميكروويف. هيا نستمر في التعرف على الموجات الدليلية والمكونات."
  },

  'quiz-hardware-physics': {
    intro: "الآن لنختبر معرفتك بأجهزة الميكروويف والفيزياء. سأقرأ كل سؤال مع 4 خيارات. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "لماذا لا تُستخدم الأسلاك الكهربائية العادية لإشارات الميكروويف عالية التردد؟",
        options: [
          "إنها ثقيلة جداً.",
          "تعاني من خسائر عالية في \"تأثير الجلد\" وتسرب الإشعاع.",
          "الميكروويف ينتقل فقط عبر البلاستيك.",
          "الأسلاك باهظة الثمن."
        ],
        correctIndex: 1,
        explanation: "عند الترددات العالية، يتدفق التيار فقط على سطح السلك، ويبدأ السلك بإشعاع الطاقة في الهواء مثل الهوائي."
      },
      {
        question: "ما هو الغرض الأساسي من الموجة الدليلية للميكروويف؟",
        options: [
          "تبريد الدائرة.",
          "تضخيم الإشارة.",
          "نقل طاقة الميكروويف بأقل خسارة.",
          "تحويل الميكروويف إلى طاقة تيار مستمر."
        ],
        correctIndex: 2,
        explanation: "صُممت الموجات الدليلية لحصر المجال الكهرومغناطيسي داخل هيكل مجوف لمنع تدهور الإشارة."
      }
    ],
    passingScore: 1,
    completionMessage: "ممتاز! أنت الآن تفهم الموجات الدليلية وأجهزة الميكروويف. هيا نستكشف الرادار والاتصالات الساتلية."
  },

  'final-quiz': {
    intro: "هذا هو الاختبار النهائي لتقييم إتقانك لتقنية الميكروويف. سأقرأ كل سؤال مع 4 خيارات. يرجى النقر على إجابتك على الشاشة.",
    questions: [
      {
        question: "لماذا هوائيات \"الطبق\" المكافئ شائعة جداً في أنظمة الميكروويف؟",
        options: [
          "تلتقط مزيداً من المطر.",
          "أسهل في الطلاء.",
          "توفر \"كسباً\" عالياً بتركيز الإشارات في شعاع ضيق وقوي.",
          "تحول الميكروويف إلى صوت."
        ],
        correctIndex: 2,
        explanation: "تماماً كمرآة المصباح اليدوي، شكل الطبق يركز الطاقة نحو نقطة واحدة."
      },
      {
        question: "أي مما يلي تطبيق يومي لتقنية الميكروويف؟",
        options: [
          "نظام التموضع العالمي (GPS)",
          "مآخذ التيار المتناوب العادية",
          "تخزين البطاريات",
          "محركات الاحتراق الداخلي"
        ],
        correctIndex: 0,
        explanation: "تبث أقمار GPS إشارات ميكروويف إلى هاتفك لحساب موقعك الدقيق على الأرض."
      }
    ],
    passingScore: 1,
    completionMessage: "تهانينا! لقد أكملت دورة تقنية الميكروويف. أنت الآن تفهم \"المسارات\" الخفية في الهواء التي تجعل العالم الحديث ممكناً."
  },
};

export const finalQuiz = {
  intro: "هذا هو التقييم النهائي. لنرى كم تعلمت عن تقنية الميكروويف.",
  questions: [
    {
      question: "ما هو النطاق الترددي النموذجي للميكروويف؟",
      correctAnswer: "300 ميجاهرتز – 300 جيجاهرتز",
      keywords: ["300", "mhz", "ghz", "ميجاهرتز", "جيجاهرتز"],
      topic: "أساسيات الميكروويف"
    },
    {
      question: "ما هو الغرض الأساسي من الموجة الدليلية؟",
      correctAnswer: "نقل طاقة الميكروويف بأقل خسارة",
      keywords: ["نقل", "ميكروويف", "طاقة", "خسارة", "أقل"],
      topic: "الموجات الدليلية"
    }
  ],
  passingScore: 1,
  completionMessage: "تهانينا! لقد أكملت دورة تقنية الميكروويف. أنت رسمياً محترف تقنية الميكروويف!"
};

const microwaveQuizzes = {
  moduleQuizzes,
  finalQuiz,
};

export default microwaveQuizzes;
